import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { AppInstallPermission, StargatePermissionId } from "./stargate.types";
import { toMarketplaceProducts, toStargateProducts } from "./stargate.utils";
export default function stargateMarketplaceMethods(self) {
  return {
    async appInstallPermission(product, cloudId) {
      const productAdminPermittedPromise = self.permitted(StargatePermissionId.MANAGE, "ari:cloud:".concat(product, "::site/").concat(cloudId));
      const siteAdminPermittedPromise = self.permitted(StargatePermissionId.MANAGE, "ari:cloud:platform::site/".concat(cloudId));
      const [productAdminPermission, siteAdminPermission] = await Promise.all([productAdminPermittedPromise, siteAdminPermittedPromise]);
      return siteAdminPermission.permitted ? AppInstallPermission.CAN_INSTALL_FREE_AND_PAID : productAdminPermission.permitted ? AppInstallPermission.CAN_INSTALL_FREE_ONLY : AppInstallPermission.CANNOT_INSTALL;
    },

    async availableSites(products) {
      const stargateProducts = toStargateProducts(products);
      const {
        sites
      } = await self.availableSites(stargateProducts);
      const marketplaceSites = sites.map(site => _objectSpread(_objectSpread({}, site), {}, {
        products: toMarketplaceProducts(site.products)
      }));
      return {
        sites: marketplaceSites
      };
    }

  };
}